import { ReactNode, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { BlankHeader } from "@/components";
import { Toaster } from "@/ui/toaster";

const BlankLayout = ({ children } : { children?: ReactNode }) => {
    const { pathname } = useLocation();

    useEffect(
        () => {
            window.scrollTo({
                behavior: "smooth",
                top: 0,
            });
        },
        [pathname],
    );

    return (
        <div className="min-h-screen bg-background">
            <Toaster />
            <div className="overflow-hidden">
                <BlankHeader />
                <main className="relative overflow-y-auto bg-background p-3 focus:outline-none md:p-6">
                    {children || <Outlet />}
                </main>
            </div>
        </div>
    );
};

export default BlankLayout;
